module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step4-52f06557bf90ddb740f893914f090c6b.jpg";